
import Logistics from "models/logistics";
const logistics = new Logistics();
export default {
  data() {
    return {
      customerList: []
    }
  },
  created() {
  },
  methods: {
    /**
     * @desc 获取客户列表
     */
    initCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
  }
}